<template>
  <div class="commonDialogBody">
           <OrganizationalStructure @AllData="getMsgFormSon" style="display:none" />
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
  <el-form-item :label="formLabelAlign.obj.code">
    <el-input v-model="formLabelAlign.methodName" size="small"></el-input>
  </el-form-item>
  <el-form-item :label="formLabelAlign.obj.name" >
    <el-select  clearable v-model="valueone" placeholder="请选择"  size="small" @change="TenementType" >
        <el-option v-for="item in optionsone" :key="item.valueone" :label="item.labelone" :value="item.valueone"></el-option>
    </el-select>
  </el-form-item>
    <el-form-item :label="formLabelAlign.obj.site" style="width:95%;">
      <div style="float:right">%</div> <el-input v-model="formLabelAlign.serviceRate" size="small" style="width:95%;float:right"></el-input>
    </el-form-item>
    <el-form-item :label="formLabelAlign.obj.floor" >
     <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import OrganizationalStructure from "../common/OrganizationalStructure.vue";
export default {
 components: {OrganizationalStructure},
  name: "ChargeDialog",
  //  props:['formLabelAlign'],
  data() {
    return {
    options:[],
     value: [],
     optionsone: [{
          valueone: '1',
          labelone: '是'
        }, {
          valueone: '0',
          labelone: '否'
        }],
        value: '',
        valueone: '',
     dialogVisible: false,
     title:"标题",
     labelPosition:'right',
     formLabelAlign:{},
     type:"",
     display:"",
     detection:"",
     UserDisplay:"",
    };
  },
  methods: {
      handleChange(value){
          //  console.log(value);
      },
      TenementType(valueone){
          // console.log(valueone)
      },
    modification(){
        if(this.title == "修改"){
            let obj = {
               "methodName":this.formLabelAlign.methodName,
               "serviceRate":this.formLabelAlign.serviceRate,
               "isService":this.valueone,
               "remarks":this.formLabelAlign.remarks,
               "id":this.formLabelAlign.id,
            }
            this.$http.post(this.$requestUrl.POST_RECEIPT_ADD,obj).then((res) => {
            let result = res.data;
             
            if (200 === result.code) {
              this.dialogVisible = false
                 this.$emit("Visible",false)
                this.$message({
                              type: 'success',
                              message: '修改成功!'
                          });
            } else {
              this.$message.error(result.msg)
            }
            }).catch(() => {
              this.$message.error(this.$errorMessage.SEVER_ERROR)
            })
        }else{
             let obj = {
               "methodName":this.formLabelAlign.methodName,
               "serviceRate":this.formLabelAlign.serviceRate,
               "isService":this.valueone,
               "remarks":this.formLabelAlign.remarks,
            }
                this.$http.post(this.$requestUrl.POST_RECEIPT_ADD,obj).then((res) => {
              let result = res.data;
               
              if (200 === result.code) {
                this.dialogVisible = false
                   this.$emit("Visible",false)
                this.$message({
                              type: 'success',
                              message: '添加成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })

        }

    },
    getMsgFormSon(data){
        // console.log(data)
        this.options = data
    },
    handleClose(done) {
     this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
        if(this.formLabelAlign.obj == undefined){
   let obj = {
            "code":"收款方式",
            "name":"是否有手续费",
            "site":"手续费费率",
            "floor":"备注信息",
          }
          this.osData = []
      this.formLabelAlign.obj = obj
    }
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>